import { IAnalyticsEvent } from '../../components/r3f-components/component-data-structure/types/analytics';
import { AnalyticsProvider } from './analyticsProvider';

export class MsClarityAnalyticsProvider extends AnalyticsProvider {
	protected _COOKIE_PREFIXES = ['_cl', 'CLID', 'ANONCHK', 'MR', 'MUID', 'SM'];
	constructor(propertyIds?: string[]) {
		super(propertyIds);
	}

	init(propertyIds: string[]): void {
		for (let i = 0; i < propertyIds.length; i++) {
			const headNode = document.getElementsByTagName('head')[0];
			const clarityTagScript = document.createElement('script');
			clarityTagScript.innerText = `(function(c,l,a,r,i,t,y){c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);})(window, document, "clarity", "script", "${propertyIds[i]}");`;
			headNode.parentElement?.insertBefore(clarityTagScript, headNode.nextSibling);
			console.log('MS Clarity loaded');
		}
	}

	updateCookieConsent(granted: boolean): void {
		if (granted) {
			window.clarity('consent');
		} else {
			this._removeCookies();
		}
	}

	sendEvent(event: IAnalyticsEvent): void {
		console.log('Send MS event');
		window.clarity('set', event.label, `${event.value}`);
	}
}
